import { useEffect, useRef, useState } from "react";


const Calandar = ({ onDateChange, initialDate }) => {
    const dateRef = useRef(null);
    // initialDate가 없으면 오늘 날짜를 기본값으로 설정
    const getDefaultDate = () => {
        if (initialDate) return initialDate;
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [selectedDate, setSelectedDate] = useState(getDefaultDate());

    useEffect(() => {
        // 라이브러리들이 로드될 때까지 대기
        const initDatePicker = () => {
            if (window.$ && window.moment && dateRef.current) {
                window.moment.locale('ko');
                window.$(dateRef.current).daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: true,
                    autoUpdateInput: false,
                    autoApply: true,
                    locale: {
                        format: 'YYYY-MM-DD',
                        separator: ' ~ ',
                        applyLabel: '적용',
                        cancelLabel: '취소',
                        fromLabel: '시작일',
                        toLabel: '종료일',
                        customRangeLabel: '사용자 지정',
                        weekLabel: '주',
                        daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
                        monthNames: ['1월', '2월', '3월', '4월', '5월', '6월',
                            '7월', '8월', '9월', '10월', '11월', '12월'],
                        firstDay: 0
                    }
                }, (date) => {
                    const dateStr = date.format('YYYY-MM-DD');
                    setSelectedDate(dateStr);
                    if (onDateChange) {
                        onDateChange(dateStr);
                    }
                    console.log('선택된 날짜:', dateStr);
                });

                // 초기값 설정 (initialDate가 있으면 그것을, 없으면 오늘 날짜를)
                const defaultDate = initialDate || getDefaultDate();
                window.$(dateRef.current).data('daterangepicker').setStartDate(window.moment(defaultDate));
                window.$(dateRef.current).data('daterangepicker').setEndDate(window.moment(defaultDate));
            
                // 싱글 데이트피커인 경우 버튼 영역 제거
                if (window.$(dateRef.current).data('daterangepicker').singleDatePicker) {
                    window.$('.daterangepicker .drp-buttons').remove();
                }
            }
        };

        // 즉시 시도
        initDatePicker();

        // 라이브러리가 아직 로드되지 않았다면 약간의 지연 후 재시도
        if (!window.$ || !window.moment) {
            const timer = setTimeout(initDatePicker, 100);
            return () => {
                clearTimeout(timer);
            };
        }

        // cleanup 함수
        return () => {
            // window.$(dateRef.current).data('daterangepicker').destroy();
        };
    }, [onDateChange, initialDate]);

    return (
        <input 
            ref={dateRef}
            type="text" 
            className="form-control"
            placeholder="날짜를 선택하세요"
            value={selectedDate}
            readOnly
        />
    )
}


const RangeCalandar = ({ onDateChange }) => {
    const dateRangeRef = useRef(null); 
    const [dateRange, setDateRange] = useState('07/01/2025 - 07/15/2025');

    useEffect(() => {
        // 라이브러리들이 로드될 때까지 대기
        const initDateRangePicker = () => {
            if (window.$ && window.moment && dateRangeRef.current) {
                window.moment.locale('ko');
                window.$(dateRangeRef.current).daterangepicker({
                    locale: {
                        format: 'YYYY-MM-DD',
                        separator: ' ~ ',
                        applyLabel: '적용',
                        cancelLabel: '취소',
                        fromLabel: '시작일',
                        toLabel: '종료일',
                        customRangeLabel: '사용자 지정',
                        weekLabel: '주',
                        daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
                        monthNames: ['1월', '2월', '3월', '4월', '5월', '6월',
                            '7월', '8월', '9월', '10월', '11월', '12월'],
                        firstDay: 0
                    },
                    startDate: window.moment().startOf('month'),
                    endDate: window.moment().endOf('month')
                }, (start, end) => {
                    // 날짜가 선택되었을 때 호출되는 콜백
                    const startDate = start.format('MM/DD/YYYY');
                    const endDate = end.format('MM/DD/YYYY');
                    const newDateRange = `${startDate} - ${endDate}`;
                    setDateRange(newDateRange);
                    console.log('선택된 날짜 범위:', newDateRange);
                    
                    // 부모 컴포넌트에 날짜 범위 전달
                    if (onDateChange) {
                        onDateChange(newDateRange);
                    }
                });
            }
        };

        // 즉시 시도
        initDateRangePicker();

        // 라이브러리가 아직 로드되지 않았다면 약간의 지연 후 재시도
        if (!window.$ || !window.moment) {
            const timer = setTimeout(initDateRangePicker, 100);
            return () => clearTimeout(timer);
        }

        return () => {
            // window.$(dateRangeRef.current).data('daterangepicker').destroy();
        };
    }, []);


    return (
        <input 
            ref={dateRangeRef}
            type="text" 
            className="form-control"
            placeholder="날짜 범위를 선택하세요"
            value={dateRange}
            readOnly
        />
    )
}

export { Calandar, RangeCalandar };
export default Calandar;